import { Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AssetLocationDto, CommunitiesDto, DivisionTblDto, LandTitleDto, LgaDto, StateDto } from '@cradua/data';
import Swal from 'sweetalert2';
import { AssetLocationTableComponent } from './asset-location-table/asset-location-table.component';

@Component({
  selector: 'cradua-asset-location',
  templateUrl: './asset-location.component.html',
  styleUrls: ['./asset-location.component.scss']
})
export class AssetLocationComponent implements OnChanges {

  @Input() activitySelectedValue: string;
  @Input() divisions: DivisionTblDto[];
  @Input() communities: CommunitiesDto[];
  @Input() lgas: LgaDto[];
  @Input() states: StateDto[];
  @Input() assetLocations: AssetLocationDto[];
  @Input() selectedLandTitle: LandTitleDto;
  @Input() isLoadingAssetLocation: boolean;
  @Output() emitSave = new EventEmitter<AssetLocationDto[]>();
  @Output() emitDelete = new EventEmitter<any>();
  @ViewChild(AssetLocationTableComponent) child: AssetLocationTableComponent;

  filterCommunities: CommunitiesDto[];
  filterLgas: LgaDto[];

  assetLocationForm: FormGroup;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnChanges(): void {
    this.createStorageLocation();
  }

  createStorageLocation() {
    this.assetLocationForm = this.fb.group({
      StateId: null,
      LgaId: null,
      DivisionId: null,
      CommunityId: null,
      AssetLocationAddress: [''],
      LandTitleId: [this.selectedLandTitle.id]
    });

  }



   protected filterById = <T>(id: string, lookupId: string) =>
   (fieldName: T) => fieldName[lookupId] === id;

   onEdit(value: AssetLocationDto) {
    this.selectedIndex = value['index'];
    this.onFilterLga(value.StateId);
    this.onFilterCommunity(value.LgaId);
    this.assetLocationForm.patchValue(value);
  }

  onFilterLga(id: string) {
    this.filterLgas = this.lgas.filter(
      this.filterById<LgaDto>(id, "StateId"),
    );
  }

  onFilterCommunity(id: string) {
    this.filterCommunities = this.communities.filter(
      this.filterById<CommunitiesDto>(id, "LgaId"),
    );
  }

   addNew(formValue: AssetLocationDto) {
    if(this.assetLocationForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.child.assetLocationFormArray['controls'][this.selectedIndex].patchValue(formValue);
      // this.onFilterLga(formValue.StateId);
      // this.onFilterCommunity(formValue.LgaId);
    } else {
      this.child.addAssetLocation(formValue);
    }
    this.selectedIndex = null;
    this.assetLocationForm.reset()
  }

   onSubmit(){
    this.emitSave.emit(this.child.assetLocationArrayForm.value['AssetLocations']);
    if(this.child.filteredDelete.length > 0) {
      this.emitDelete.emit(this.child.filteredDelete);
    }
  }

  onReset() {
    this.assetLocationForm.reset();
    this.selectedIndex = null;
  }



}
